export default {"src":"/_next/static/media/basket.fa82eedd.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};